import React from 'react';

import PropTypes from 'prop-types';
import { priorAuthorizationReferralDetailsPropType } from './types';
import { ReviewSectionStyle } from 'App/components/EHR/styles';

const PANotRequiredReviewContent = ({ priorAuthorizationReferralDetails, status }) => {
    return (
        <div>
            <ReviewSectionStyle>
                <strong>Referral Details (Prior Authorization)</strong>

                <div>Status: {status}</div>
            </ReviewSectionStyle>

            <ReviewSectionStyle>
                <strong>Notes</strong>
                <div>{priorAuthorizationReferralDetails.notes || '--'}</div>
            </ReviewSectionStyle>
        </div>
    );
};

PANotRequiredReviewContent.propTypes = {
    status: PropTypes.string.isRequired,
    priorAuthorizationReferralDetails: priorAuthorizationReferralDetailsPropType.isRequired,
};

export default PANotRequiredReviewContent;
